import { gql } from '@apollo/client';

const GET_OPERATIONAL_COSTS = gql`
  query operationalCosts {
    operationalCosts {
      procedures {
        name
        price
        selected
      }
      totalOperationalCost
    }
  }
`;

const GET_SAVED_OPERATIONAL_COSTS = gql`
  query persistedOperationalCosts {
    persistedOperationalCosts {
      procedures {
        name
        price
        selected
      }
      totalOperationalCost
    }
  }
`;

const SELECT_PROCEDURES = gql`
  mutation createOperationalCosts(
    $createOperationalCostsInput: CreateOperationalCostsInput!
  ) {
    createOperationalCosts(
      createOperationalCostsInput: $createOperationalCostsInput
    ) {
      procedures {
        name
        price
        selected
      }
      totalOperationalCost
    }
  }
`;

const GET_VOUCHER = gql`
  query operationalCostsVoucher(
    $operationalCostsVoucherInput: [SelectedProceduresInput!]!
  ) {
    operationalCostsVoucher(
      operationalCostsVoucherInput: $operationalCostsVoucherInput
    )
  }
`;

const proceduresOperations = {
  GET_OPERATIONAL_COSTS,
  GET_VOUCHER,
  GET_SAVED_OPERATIONAL_COSTS,
  SELECT_PROCEDURES,
};

export default proceduresOperations;
